module.exports = __webpack_public_path__ + "img/download.0fcaa653.svg";